module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/nano_01_sp-d6857a70b2fcf8ae8a741c1afe850496.png";